import Img from 'react-image';

import React from 'react'

const CDNImage = props => {
	return (
		<Img
			{...props}
			src={`${process.env.REACT_APP_ASSET_URL}images/${props.image_name}`}
		/>
	);
}

export default CDNImage;
